import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from "@angular/router";
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { OpenRoutePropertyController } from '@shared/src/controllers/open/open.route.property.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { SlotInfoDto } from '@shared/src/dtos/address/slots/SlotInfoDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { OpenResource } from '@shared/src/dtos/open/OpenResource';
import { PhaseCardItemDto } from '@shared/src/dtos/phase/PhaseCardItemDto';
import { PhaseSlotChangeReasonDataInfoDto } from '@shared/src/dtos/phase/slot/manage/reason/PhaseSlotChangeReasonDataInfoDto';
import { PhaseSlotChangeReasonActionTypes } from '@shared/src/enums/PhaseSlotChangeReasonActionTypes';
import { AddressTimetableIntervalDto, AlertService, HDate, HHourInterval, HomeController, HString, SharedSlotPickerComponent } from '@shared/src/public-api';

@Component({
    selector: 'shared-exwork-slotpicker-component',
    templateUrl: './shared.exwork.slotpicker.component.html',
    styleUrls: ['./shared.exwork.slotpicker.component.scss']
})
export class SharedExworkSlotPickerComponent implements OnInit {
    constructor(protected activatedRoute: ActivatedRoute, public dialog: MatDialog,
        public openRouteController: OpenRouteController,
        public openRoutePropertyController: OpenRoutePropertyController, public systemController: SystemController,
        @Inject('HomeController') public homeController: HomeController,
        @Inject('AlertService') public alertService: AlertService) {
    }

    ngOnInit(): void {
    }

    @Input()
    public driver: boolean = false;

    public __uuid: string;
    @Input()
    public set uuid(value: string) {
        if (this.__uuid == value)
            return;
        this.__uuid = value;
        this.getInfo();
    }
    public get uuid(): string {
        return this.__uuid;
    }

    public __phase: PhaseCardItemDto;
    @Input()
    public set phase(value: PhaseCardItemDto) {
        if (this.__phase == value)
            return;
        this.__phase = value;
        this.getInfo();
    }
    public get phase(): PhaseCardItemDto {
        return this.__phase;
    }

    @Input()
    public slotInfo: SlotInfoDto;

    public __autoOpen: boolean;
    @Input()
    public set autoOpen(value: boolean) {
        if (this.__autoOpen == value)
            return;
        this.__autoOpen = value;
        this.getInfo();
    }
    public get autoOpen(): boolean {
        return this.__autoOpen;
    }

    @Input()
    public readonly: boolean = false;
    
    public realDate: HDate;
    public nooptions: boolean = false;
    public showObservacions: boolean = false;
    public canSlotRelease: Boolean = false;
    public realInterval: HHourInterval;
    public loading = false;
    public canShowPropertiesButton: boolean = false;

    @Input()
    public avoidPropertyPendingResponse: boolean = false;


    public actions: ActionsStripDto; 
    public calcularActions() {
        this.actions = new ActionsStripDto();
        if (this.canShowPropertiesButton) {
            this.actions.add(ActionDto.build("PROPERTIES", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.PROPERTIES", "", "", 15, -1, 0, "").actionGO());
        }
        this.actions.add(ActionDto.build("RELOAD", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.RELOAD", "", "fa-refresh", 10, 1, 0, "").default());
        if (this.canSlotRelease)
            this.actions.add(ActionDto.build("CANCEL", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.CANCEL", "", "fa-ban", 20, 0, 0, "").danger());
    }
    public onClickAction(action: ActionDto) {
        if (action == null)
            return;
        if (action.actionId === "RELOAD")
            this.getSlots(true, false);
        else if (action.actionId === "CANCEL")
            this.clickAlliberarSlot();
        else if (action.actionId === "PROPERTIES")
            this.onClickShowProperties();
    }

    public loadingExistsPropertiesLinkedToSlots: boolean = false;
    getInfo() {
        if(HString.isNullOrNullString(this.uuid))
            return;

        if(!this.loadingExistsPropertiesLinkedToSlots){
            this.loadingExistsPropertiesLinkedToSlots = true;
            if(!this.driver){
                this.openRoutePropertyController.getExworkExistsPropertiesLinkedToSlots(this.uuid).subscribe(data => {
                    this.loadingExistsPropertiesLinkedToSlots = false;
                    this.canShowPropertiesButton = data;
                    this.calcularActions();
                });
            }else{
                this.openRoutePropertyController.getDriverExistsPropertiesLinkedToSlots(this.uuid).subscribe(data => {
                    this.loadingExistsPropertiesLinkedToSlots = false;
                    this.canShowPropertiesButton = data;
                    this.calcularActions();
                });
            }
        }
        
        if (this.autoOpen)
            this.getSlots(false, true);
    }

    
    public loadingPendingResponse: boolean = false;
    public existsPropertiesLinkedToSlotsPendingResponse: boolean = false;
    getSlots(busy: boolean, withalwaysask: boolean) {
        if (!this.phase || this.loadingPendingResponse)
            return;
        if(HString.isNullOrNullString(this.uuid))
            return;

        if(this.avoidPropertyPendingResponse){
            this.loadingPendingResponse = false;
            this.existsPropertiesLinkedToSlotsPendingResponse = false;
            this.__getSlots(busy);
            return;
        }

        this.loadingPendingResponse = true;
        if (!this.driver) {
            this.openRoutePropertyController.getExworkExistsPropertiesLinkedToSlotsPendingResponse(this.uuid, withalwaysask).subscribe(data => {
                this.loadingPendingResponse = false;
                this.existsPropertiesLinkedToSlotsPendingResponse = data;
                if (!this.existsPropertiesLinkedToSlotsPendingResponse) {
                    this.__getSlots(busy);
                }
            });
        } else {
            this.openRoutePropertyController.getDriverExistsPropertiesLinkedToSlotsPendingResponse(this.uuid, withalwaysask).subscribe(data => {
                this.loadingPendingResponse = false;
                this.existsPropertiesLinkedToSlotsPendingResponse = data;
                if (!this.existsPropertiesLinkedToSlotsPendingResponse) {
                    this.__getSlots(busy);
                }
            });
        }

    }
    onRefreshExistsPropertiesLinkedToSlotsPendingResponse(event) {
        if (event)
            if (!event.previousPhaseCreated && !event.actualPhaseDeleted)
                this.getSlots(true, false);
    }

    onClickShowProperties() {
        if(HString.isNullOrNullString(this.uuid))
            return;
        if (!this.driver) {
            this.homeController.openAsideExworkRouteProperties(this.uuid).then(value => {
                this.slotChanged.next();
            });
        } else {
            this.homeController.openAsideDriverRouteProperties(this.uuid).then(value => {
                this.slotChanged.next();
            });
        }
    }

    public show: boolean;
    private __getSlots(busy: boolean) {
        this.show = true;
        this.loading = true;
        this.nooptions = false;
        this.canSlotRelease = false;
        if (this.uuid && this.phase) {
            if (this.driver)
                this.openRouteController.getDriverSlotsByPhaseId(this.uuid, this.phase.phaseId, busy).subscribe(data => {
                    this.intervals = data;
                    this.loading = false;
                    this.openRouteController.getDriverCanReleaseSlotsByPhaseId(this.uuid, this.phase.phaseId).subscribe(data => {
                        this.canSlotRelease = data;

                        if (!this.canSlotRelease && this.intervals != null && this.intervals.length == 0)
                            this.nooptions = true;
                    });
                });
            else
                this.openRouteController.getExworkSlotsByPhaseId(this.uuid, this.phase.phaseId, busy).subscribe(data => {
                    this.intervals = data;
                    this.loading = false;
                    this.openRouteController.getExworkCanReleaseSlotsByPhaseId(this.uuid, this.phase.phaseId).subscribe(data => {
                        this.canSlotRelease = data;

                        if (!this.canSlotRelease && this.intervals != null && this.intervals.length == 0)
                            this.nooptions = true;
                    });
                });

            if (this.phase != null && this.phase.intervalInfo != null && this.phase.intervalInfo.addressTimetableIntervalId != 0) {
                this.showObservacions = SharedSlotPickerComponent.getShowObservacions(this.phase.intervalInfo);
                if (this.showObservacions) {
                    this.realDate = SharedSlotPickerComponent.getRealDate(this.phase.intervalInfo);
                    this.realInterval = SharedSlotPickerComponent.getRealInterval(this.phase.intervalInfo);
                }
            }
        }
    }
    public getRealIntervalFunc = SharedSlotPickerComponent.getRealInterval;
    public getRealDateFunc = SharedSlotPickerComponent.getRealDate;
    public getShowObservacionsFunc = SharedSlotPickerComponent.getShowObservacions;
    isSelected(addressinterval: AddressTimetableIntervalDto) {
        return addressinterval != null
            && this.slotInfo != null
            && this.slotInfo.addressTimetableIntervalId === addressinterval.addressTimetableIntervalId;
    }
    clickAlliberarSlot() {
        this.intervals = null;
         if(HString.isNullOrNullString(this.uuid))
            return;
        if (this.driver)
            this.openRouteController.getDriverRequiredSlotChangeReason(this.uuid, this.phase.phaseId, PhaseSlotChangeReasonActionTypes.SetSlotDriver).subscribe((data: boolean) => {
                if (data) {
                    this.homeController.openAsideDriverPhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildCancelDriver(this.uuid, this.phase.phaseId)).then(value => {
                        this.slotChanged.next();
                        this.cancel();
                    });
                } else {
                    this.openRouteController.clearDriverPhaseSlot(this.uuid, this.phase.phaseId, new Array()).subscribe(data => {
                        this.slotChanged.next();
                        this.cancel();
                    });
                }
            });
        else
            this.openRouteController.getExworkRequiredSlotChangeReason(this.uuid, this.phase.phaseId, PhaseSlotChangeReasonActionTypes.SetSlotExwork).subscribe((data: boolean) => {
                if (data) {
                    this.homeController.openAsideExworkPhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildCancelExwork(this.uuid, this.phase.phaseId)).then(value => {
                        this.slotChanged.next();
                        this.cancel();
                    });
                } else {
                    this.openRouteController.clearExworkPhaseSlot(this.uuid, this.phase.phaseId, new Array()).subscribe(data => {
                        this.slotChanged.next();
                        this.cancel();
                    });
                }
            });

    }
    @Output()
    slotChanged: EventEmitter<void> = new EventEmitter();
    onIntervalSelected(item: AddressTimetableIntervalDto) {
        if(HString.isNullOrNullString(this.uuid))
            return;
        this.intervals = null;
        if (this.driver)
            this.openRouteController.getDriverRequiredSlotChangeReason(this.uuid, this.phase.phaseId, PhaseSlotChangeReasonActionTypes.SetSlotDriver).subscribe((data: boolean) => {
                if (data) {
                    this.homeController.openAsideDriverPhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildSetSlotDriver(this.uuid, this.phase.phaseId, item)).then(value => {
                        this.__autoOpen = false;
                        this.slotChanged.next();
                        this.cancel();
                    });
                } else {
                    if (!HLong.isNullOrNullLong(item.addressDaySettingResourceId)) {
                        this.openRouteController.setDriverPhaseSlotByResource(this.uuid, this.phase.phaseId, item.addressDaySettingResourceId, OpenResource.build(item), new Array()).subscribe(data => {
                            this.__autoOpen = false;
                            this.slotChanged.next();
                            this.cancel();
                        });
                    } else if (!HLong.isNullOrNullLong(item.addressTimetableIntervalId)) {
                        this.openRouteController.setDriverPhaseSlot(this.uuid, this.phase.phaseId, item.addressTimetableIntervalId, new Array()).subscribe(data => {
                            this.__autoOpen = false;
                            this.slotChanged.next();
                            this.cancel();
                        });
                    }
                }
            });
        else
            this.openRouteController.getExworkRequiredSlotChangeReason(this.uuid, this.phase.phaseId, PhaseSlotChangeReasonActionTypes.SetSlotExwork).subscribe((data: boolean) => {
                if (data) {
                    this.homeController.openAsideExworkPhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildSetSlotExwork(this.uuid, this.phase.phaseId, item)).then(value => {
                        this.__autoOpen = false;
                        this.slotChanged.next();
                        this.cancel();
                    });
                } else {
                    if (!HLong.isNullOrNullLong(item.addressDaySettingResourceId)) {
                        this.openRouteController.setExworkPhaseSlotByResource(this.uuid, this.phase.phaseId, item.addressDaySettingResourceId, OpenResource.build(item), new Array()).subscribe(data => {
                            this.__autoOpen = false;
                            this.slotChanged.next();
                            this.cancel();
                        });
                    } else if (!HLong.isNullOrNullLong(item.addressTimetableIntervalId)) {
                        this.openRouteController.setExworkPhaseSlot(this.uuid, this.phase.phaseId, item.addressTimetableIntervalId, new Array()).subscribe(data => {
                            this.__autoOpen = false;
                            this.slotChanged.next();
                            this.cancel();
                        });
                    }
                }
            });
    }

    private _intervals: Array<AddressTimetableIntervalDto>
    public set intervals(value: Array<AddressTimetableIntervalDto>) {
        if (this._intervals === value)
            return;
        this._intervals = value;
        this.loadIntervals();
    }
    public get intervals(): Array<AddressTimetableIntervalDto> {
        return this._intervals;
    }

    public addressintervals: AddressTimetableIntervalDto[];
    loadIntervals() {
        this.addressintervals = [];

        if (!this.intervals)
            return;

        if (this.intervals == null || this.intervals.length <= 0)
            return;

        this.intervals.forEach(element => {
            if (!HHourInterval.isNullOrNullValue(element.interval))
                this.addressintervals.push(element);
        });

        if (this.phase == null || this.phase.intervalInfo == null)
            return;
        if (HHourInterval.isNullOrNullValue(this.phase.intervalInfo.interval))
            return;
        /*
        * Afegeix l'interval reservat, indicat per slotInfo, quan no està present al llistat d'intervals
        * d'una fase retornats pel back.
        * */
        let isInTheList = false;
        for (const addressinterval of this.addressintervals) {
            if (addressinterval.addressTimetableIntervalId === this.phase.intervalInfo.addressTimetableIntervalId) {
                isInTheList = true;
                break
            }
        }
        if (!isInTheList) {
            this.addressintervals.push(this.phase.intervalInfo);
        }

    }

    /***
         * True si el n-essim element item te una data diferent a l'anterior
         */
    public trencaData(i: number, item: AddressTimetableIntervalDto): boolean {
        if (i == 0)
            return true;
        let prev = this.addressintervals[i - 1];
        return !HDate.equals(item.onDate, prev.onDate);
    }

    public slotChangedAside(value) {
        this.slotChanged.next();
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }
    public cancel() {
        this.show = false;
        this.canSlotRelease = false;
        this.intervals = null;
    }
}
